var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { useComponents } from '@tencent/dz-elements';
import { HospitalHeader, HospitalModal } from '../../../components';
import { useMobileModel, useConsultModel, useHeaderModel } from '../../../hooks';
import styles from './style/index.less';
import { hospitalFormat } from '../../../utils';
import { useReportSerivce } from './useReportSerivce';
export var TopHospital = function () {
    var hospital = useHeaderModel().hospital;
    var config = useConsultModel().getConsultConfig();
    var _a = useState(false), showModal = _a[0], setShowModal = _a[1];
    // 电话咨询
    var mobileModel = useMobileModel();
    var View = useComponents().View;
    // 是否有hospital
    if (!hospital || !hospital.hospitalId)
        return null;
    var quickTelEnable = config.quick_tel_enable === 1;
    var report = useReportSerivce({ hospital: hospital, config: config });
    var onTellClick = function (e) {
        mobileModel.callByComponentId(config.quick_tel_component_id, report.reportModuleParams.module);
        // 阻止事件冒泡
        e.stopPropagation();
    };
    var onShowDetail = function () {
        setShowModal(true);
        report.hospitalClick();
        report.hospitalModalExposure();
    };
    var hospitalData = __assign(__assign({}, hospital), { environment: hospital.environmentImage || [], establishmentDate: hospital.establishTime, desc: hospital.introduction, location: hospital.address, serviceTime: hospitalFormat.businessHours(hospital.businessHours), id: hospital.hospitalId });
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { className: styles['fixed-search-Hospital'], id: "fixed-search-Hospital", onClick: onShowDetail },
            React.createElement(HospitalHeader, { style: { padding: 10 }, hospitalData: hospitalData, type: "fixed" }, quickTelEnable && (React.createElement(View, { className: styles['search-header-tel'] },
                React.createElement(View, { className: styles['icon-tel'], onClick: onTellClick }))))),
        React.createElement(HospitalModal, { hospital: hospitalData, show: showModal, onHide: function () {
                setShowModal(false);
            } })));
};
